import { provideZoneChangeDetection } from "@angular/core";
// import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { platformBrowser } from "@angular/platform-browser";

import { AppModule } from './app/app.module';

// platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
//   .catch(err => console.error(err));

platformBrowser().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], }).catch(err => console.error(err));